export const state = () => ({
	accountManagers: [],
});

export const mutations = {
	setAccountManagers(state: any, payload: any) {
		state.accountManagers = payload;
	},
};
export const getters = {
	getAccountManagers: (state: any) => state.accountManagers,
};

export const actions = {
	async login(state: any, payload: any) {
		const { token, signature, ...data } = payload;

		await this.$axios.get('sanctum/csrf-cookie');

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`/api/account-managers/${token}/login?signature=${signature}`, data)
				.then(async (res) => {
					await this.$auth.setUserToken(200);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getAccountManagers(state: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/account-managers')
				.then(async (res) => {
					state.commit('setAccountManagers', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createAccountManager(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/account-managers', payload)
				.then(async (res) => {
					let accountManagers = JSON.parse(JSON.stringify(state.state.accountManagers));

					accountManagers.unshift(res.data);

					state.commit('setAccountManagers', accountManagers);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteAccountManager(state: any, account_manager_uuid: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete(`/api/account-managers/${account_manager_uuid}`)
				.then(async (res) => {
					let accountManagers = JSON.parse(JSON.stringify(state.state.accountManagers)).filter((i) => i.uuid !== account_manager_uuid);

					state.commit('setAccountManagers', accountManagers);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
